import { useAppSelector } from "../../hooks/StoreHooks";

export const useAllNotificationList = () =>
    useAppSelector((state) => state.notifications.allNotificationList);
  
  export const useUnreadNotificationList = () =>
    useAppSelector((state) => state.notifications.unreadNotificationList);

export const useUnreadNotificationAmount = () =>
    useAppSelector((state) => state.notifications.unreadNotificationAmount);

export const useNotificationToEdit = () =>
    useAppSelector((state) => state.notifications.notificationToEdit);